import axios from 'axios';

export function formatTime(seconds: number) {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return `${hrs > 0 ? hrs.toString() + 'h' : ''} 
    ${mins > 0 ? mins.toString() + 'min' : ''}
    ${secs > 0 || (hrs == 0 && mins == 0)? secs.toString() + 'sec' : ''}`;
}

type ApiResult<T> = [T | null, Error | null];

export async function fetchBE(url: string): Promise<ApiResult<any>> {
  try {
      const response = await axios.get(url, {
        withCredentials: true
      });
      return [response.data, null]
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error('Errore Axios:', error.message);
      if (error.response) {
        console.error('Status code:', error.response.status);
        console.error('Dati errore:', error.response.data);
      } else if (error.request) {
        console.error('Nessuna risposta ricevuta:', error.request);
      } else {
        console.error('Errore generico:', error.message);
      }
    } else {
      console.error('Errore non Axios:', error);
      throw new Error('Errore comunicazione con backend');
    }
    return [null, error as Error];
  }
}